import { api } from './client'

export interface ColorScheme {
  id: string
  user_id: string
  name: string
  bg: string
  fg: string
  color1: string
  color2: string
  created_at: string
  updated_at: string
}

export interface SchemeCreate {
  name: string
  bg: string
  fg: string
  color1: string
  color2: string
}

export interface SchemeUpdate {
  name?: string
  bg?: string
  fg?: string
  color1?: string
  color2?: string
}

export function listSchemes(username: string): Promise<ColorScheme[]> {
  return api.get<ColorScheme[]>(`/users/${username}/schemes`)
}

export function createScheme(username: string, body: SchemeCreate): Promise<ColorScheme> {
  return api.post<ColorScheme>(`/users/${username}/schemes`, body)
}

export function updateScheme(username: string, schemeId: string, body: SchemeUpdate): Promise<ColorScheme> {
  return api.patch<ColorScheme>(`/users/${username}/schemes/${schemeId}`, body)
}

export function deleteScheme(username: string, schemeId: string): Promise<void> {
  return api.delete(`/users/${username}/schemes/${schemeId}`)
}

export function copyScheme(sourceUsername: string, schemeId: string, name?: string): Promise<ColorScheme> {
  return api.post<ColorScheme>(`/users/${sourceUsername}/schemes/${schemeId}/copy`, { name })
}

export interface GlobalTheme {
  bg: string
  fg: string
  color1: string
  color2: string
}

export function getGlobalTheme(): Promise<GlobalTheme> {
  return api.get<GlobalTheme>('/admin/global-theme')
}

export function setGlobalTheme(theme: GlobalTheme): Promise<GlobalTheme> {
  return api.put<GlobalTheme>('/admin/global-theme', theme)
}
